var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TimePickerCalendar from 'react-calendar';
import styled from 'styled-components';
import Label from '../Label/Label';
import Error from '../Error/Error';
const PickerStyle = styled.div `
  display: inline-block;
  margin: ${props => props.theme.paddingsMargins.themeMenuMargin};
  & .react-calendar {
    padding: ${props => props.theme.paddingsMargins.inputsPadding};
    border-radius: ${props => props.theme.borders.borderRadius};
    border: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('grey'))};
    &:hover {
      border: ${props => props.theme.utils.getColor(props.color)};
    }
  }
  & div {
    color: ${props => props.theme.utils.getColor(props.color)};
  }
  & .react-calendar__tile--active {
    background-color: ${props => props.theme.utils.getColor(props.color)};
      &:enabled:hover{
        background-color: ${props => props.theme.utils.getColorLight(props.color)};
      }
  };
  & .react-calendar__tile--hasActive{
    background-color: ${props => props.theme.utils.getColorLight(props.color)};
      }
  }
  }
`;
const Calendar = (_a) => {
    var { value, onChange, label, labelSize = 'article', register, errors = {}, name, selectRange, color = 'main', labelColor } = _a, props = __rest(_a, ["value", "onChange", "label", "labelSize", "register", "errors", "name", "selectRange", "color", "labelColor"]);
    return (_jsxs(PickerStyle, Object.assign({ color: color }, props, { children: [!!label && (_jsx(Label, { label: label, labelSize: labelSize, color: labelColor || color })), _jsx(TimePickerCalendar, { selectRange: selectRange, locale: "en-US", onChange: e => onChange, value: value, className: "date-picker" }), !!errors[name] && _jsx(Error, { children: errors[name].message })] })));
};
export default Calendar;
